module.exports = __webpack_public_path__ + "img/1360259523.1caca38f.jpg";